import { getIn, useFormik } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { ISurveyQuestion } from "../../../../../../../../../@types/Surveys";
import { TextArea } from "../../../../../../../../../components/TextArea";
import { TextField } from "../../../../../../../../../components/TextField";
import { FieldRow, FullWidth } from "../../../../../../SurveyBuilder.styles";

interface IQuestionInfoProps {
  onTitleChange: any;
  onDescriptionChange: any;
  question?: ISurveyQuestion;
  setQuestionInfoIsValidated: any;
  triggerValidation: boolean | undefined;
}

interface IQuestionInfoInitialValues {
  title: string;
  description: string;
}

export function QuestionInfo({
  onTitleChange,
  onDescriptionChange,
  question,
  triggerValidation,
  setQuestionInfoIsValidated,
}: IQuestionInfoProps) {
  const { t } = useTranslation();

  const initialValues: IQuestionInfoInitialValues = {
    title: question?.text ?? "",
    description: question?.description ?? "",
  };

  const questionInfoValidation = yup.object().shape({
    title: yup
      .string()
      .required(t("surveys_builder_questionInfo_titleRequired")),
  });

  const questionInfoFormik = useFormik({
    initialValues,
    onSubmit: () => {},
    validationSchema: questionInfoValidation,
  });

  useEffect(() => {
    onTitleChange(questionInfoFormik.values.title);
    onDescriptionChange(questionInfoFormik.values.description);
  }, [questionInfoFormik.values]);

  const shouldShowErrorMessage = () => {
    return questionInfoFormik.touched.title
      ? getIn(questionInfoFormik.errors, "title")
      : "";
  };

  useEffect(() => {
    if (triggerValidation !== undefined) questionInfoFormik.submitForm();
  }, [triggerValidation]);

  useEffect(() => {
    if (
      questionInfoFormik.values.title === "" ||
      questionInfoFormik.errors.title !== undefined
    ) {
      setQuestionInfoIsValidated(false);
    } else {
      setQuestionInfoIsValidated(true);
    }
  }, [questionInfoFormik.values.title, questionInfoFormik.errors.title]);

  return (
    <>
      <FieldRow>
        {t("surveys_builder_questionInfo_question")}
        <TextField
          maxLength={200}
          label=""
          name="title"
          placeholder={t("surveys_builder_question_titlePlaceholder")}
          value={questionInfoFormik.values.title}
          onChange={questionInfoFormik.handleChange}
          backgroudColor="white"
          errorMessage={shouldShowErrorMessage()}
        />
      </FieldRow>
      <FieldRow>
        {t("surveys_builder_questionInfo_briefExplanation")}
        <FullWidth>
          <TextArea
            maxLength={200}
            name="description"
            placeholder={t("surveys_builder_question_descriptionPlaceholder")}
            value={questionInfoFormik.values.description}
            onChange={questionInfoFormik.handleChange}
            backgroudColor="white"
            rows={2}
          />
        </FullWidth>
      </FieldRow>
    </>
  );
}
